import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Button from "./Button";
import { AppContext } from "../utils/context";

class CheckoutProcessing extends Component {

  render() {
    const { title, paysafe_after_payclick, paysafe_status, initPaysafe, shift4Loading, paysafeLoading } = this.props;
    const { localLanguage, settings, config } = this.context;
    return (
      <form key={4} className="w-full checkoutProcessing">
        <Helmet>
          {settings.scripts_payment_info && <script>{settings.scripts_payment_info}</script>}
        </Helmet>
        {config.webPayments !== "shift4" && <h2 className="mb-6">{title}</h2>}
        <div className="flex flex-wrap items-center justify-center min-h-64">
          <div className="w-full max-w-md mx-auto text-center" id="paymentInfoWrapper">

            {config.webPayments === 'paysafe' && paysafeLoading && ( // Paysafe checkout loader
              <div className="flex flex-col items-center justify-center text-center py-8">
                <div className="flex items-center justify-center text-2xl text-primary mb-4">
                  <div className="bump-loader mr-4">
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                  <span className="font-medium">
                    {paysafe_after_payclick ? localLanguage.general_processing_payment : localLanguage.general_payment_redirect}
                  </span>
                </div>
              </div>
            )}

            {(config.webPayments === 'stripe' || config.webPayments === 'mmg') && ( // Stripe checkout loader
              <div className="flex flex-col items-center justify-center text-center py-8">
                <div className="flex items-center justify-center text-2xl text-primary mb-4">
                  <div className="bump-loader mr-4">
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                  <span className="font-medium">
                    {window.location.href.includes('process-order') ? localLanguage.general_processing_payment : localLanguage.general_payment_redirect}
                  </span>
                </div>
              </div>
            )}

            {config.webPayments === 'shift4' && ( // Shift4 checkout
                <>
                    <div id="i4goFrame"></div>

                    {shift4Loading ? (
                      <div className="flex flex-col items-center justify-center text-center py-8">
                        <div className="flex items-center justify-center text-2xl text-primary">
                          <div className="bump-loader mr-4">
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                        </div>
                      </div>
                    ) :
                      <>
                        <button
                          className="pay-button pay-hidden google-pay-button"
                          style={{backgroundColor: '#4285F4', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '4px', marginBottom: '10px'}}
                          type="button"
                        >
                        </button>

                        <button
                          className="pay-button pay-hidden apple-pay-button"
                          style={{backgroundColor: 'black', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '4px' }}
                          type="button"
                        >
                        </button>
                      </>
                    }
                </>
            )}

            {config.webPayments === 'paysafe' && !paysafe_status && !paysafeLoading && ( // Paysafe iframe closed by user
              <div className="flex flex-col items-center justify-center text-center py-8">
                <div className="mb-6">
                  <svg className="w-16 h-16 mx-auto text-yellow-500 mb-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">{localLanguage.general_payment_cancelled}</h3>
                </div>
                <div className="flex flex-col sm:flex-row gap-4 justify-center w-full max-w-sm">
                  <Link
                    to={"/"}
                    className="inline-flex items-center justify-center py-3 px-6 bg-red-600 hover:bg-red-700 text-white rounded-md shadow-md transition-colors duration-200 no-underline font-medium"
                  >
                    {localLanguage.general_cancel_order}
                  </Link>
                  <Button onClick={() => initPaysafe()} color="primary" content={localLanguage.general_make_payment} rounded />
                </div>
              </div>
            )}

          </div>
        </div>
      </form>
    );
  }
}
CheckoutProcessing.contextType = AppContext;

export default CheckoutProcessing;
